import {
    forwardRef,
    useRef,
    useEffect,
    useImperativeHandle,
    useCallback,
} from 'react';
import { noop, get } from 'lodash';
import { Form } from 'react-bootstrap';
import { Controller } from 'react-hook-form';
import './Input.scss';
import { Autocomplete } from '@mui/material';
import ErrorMessage from 'components/Common/ErrorMessage';
import { useNodeContext } from 'contexts/NodeProvider';

const SearchableSelect = forwardRef(
    (
        {
            control,
            name,
            defaultValue = '',
            label,
            options = [],
            disabled,
            onChange = noop,
            required,
            registerRef = true,
        },
        ref
    ) => {
        const _ref = useRef();
        const { nodesRef } = useNodeContext();

        useImperativeHandle(ref, () => _ref.current);

        useEffect(() => {
            if (nodesRef) {
                nodesRef.current[name] = _ref.current;
            }
        }, []);

        return (
            <div className="select-field">
                <Controller
                    control={control}
                    name={name}
                    defaultValue={defaultValue}
                    render={({
                        field: { value, onChange: handleChange, ref: rhfRef },
                        fieldState: { error },
                    }) => {
                        const onRefChange = useCallback((node) => {
                            if (registerRef) {
                                _ref.current = node;
                                rhfRef = _ref;
                                if (nodesRef) {
                                    nodesRef.current[name] = node;
                                }
                            }
                        }, []);
                        // The MUI Autocomplete expects the value to be an object with the label and value
                        const autoCompleteValue = options.find(
                            (option) => option.value === value
                        );
                        return (
                            <>
                                <Form.Group className="pt-3">
                                    <Form.Label
                                        className="h5"
                                        id={`label-question-select-${name}`}
                                    >
                                        {label}{' '}
                                        <span className="text-danger">
                                            {required ? ' *' : ' '}
                                        </span>
                                    </Form.Label>
                                    <Autocomplete
                                        ref={onRefChange}
                                        renderInput={(params) => (
                                            <div
                                                ref={params.InputProps.ref}
                                                className="position-relative"
                                            >
                                                <Form.Control
                                                    placeholder="Select..."
                                                    {...params.inputProps}
                                                />
                                                {params.InputProps.endAdornment}
                                            </div>
                                        )}
                                        id={`label-question-select-${name}`}
                                        defaultValue={defaultValue}
                                        value={autoCompleteValue ?? null}
                                        options={options}
                                        onChange={(e, selectedOption) => {
                                            onChange(selectedOption.value);
                                            handleChange(selectedOption.value);
                                        }}
                                        disabled={disabled}
                                    />
                                </Form.Group>
                                <ErrorMessage message={get(error, 'message')} />
                            </>
                        );
                    }}
                />
            </div>
        );
    }
);

export default SearchableSelect;
